import { Rule } from 'antd/es/form';

type CustomFormValidationRuleParams = {
  message?: string;
};

export const customFormValidationRules: Record<
  string,
  (params: CustomFormValidationRuleParams) => Rule
> = {
  noLeadingOrTrailingSpaces: ({
    message = 'Value cannot have leading or trailing spaces',
  }) => ({
    validator: (_, value) => {
      if (value && (value.startsWith(' ') || value.endsWith(' '))) {
        return Promise.reject(message);
      }
      return Promise.resolve();
    },
  }),
};
